"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalizedCategory = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useLocalizedCategory = function (category) {
    var geoCountry = (0, swr_hooks_1.useGeoCountry)();
    var data = (0, swr_hooks_1.useGamesByCategories)().data;
    return (0, react_1.useMemo)(function () {
        if (!geoCountry || !data)
            return category;
        var localizedCategory = "".concat(category, "_").concat(geoCountry.toLowerCase());
        return (data === null || data === void 0 ? void 0 : data[localizedCategory]) ? localizedCategory : category;
    }, [data, geoCountry, category]);
};
exports.useLocalizedCategory = useLocalizedCategory;
